module.exports = __webpack_public_path__ + "i18n/pl.4f4a750a437b05fe960dc9a23642d3a1.json";